export default "__VITE_ASSET__436d622d__"